/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Phase_3_DescriptionInputs */

const en_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep building your focus progress to enrich your forest and fuel your motivation to keep going.`)
};

const ar_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واصل بناء تقدّمك في التركيز لتُثري غابتك وتغذّي دافعك للاستمرار.`)
};

const de_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bauen Sie Ihren Fokus-Fortschritt weiter aus, um Ihren Wald zu bereichern und Ihre Motivation zum Weitermachen zu steigern.`)
};

const es_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continúa desarrollando tu concentración para enriquecer tu bosque y alimentar tu motivación para seguir adelante.`)
};

const fr_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuez à cultiver vos progrès en concentration pour enrichir votre forêt et nourrir votre envie de persévérer.`)
};

const it_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua a migliorare la tua concentrazione per arricchire la tua foresta e alimentare la tua motivazione a continuare.`)
};

const ja_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中を積み重ね、森を豊かに育て、モチベーションを高めましょう。`)
};

const ko_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중력 진행 상황을 계속 누적하여 숲을 풍성하게 만들고 성장을 향한 동기를 부여받으세요.`)
};

const pt_br_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue desenvolvendo seu progresso de foco para enriquecer sua floresta e alimentar sua motivação para continuar adiante.`)
};

const ru_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжайте развивать свой прогресс концентрации, чтобы обогатить свой лес и подпитать мотивацию двигаться дальше.`)
};

const th_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างพัฒนาการในการโฟกัสของคุณต่อไปเพื่อทำให้ป่าของคุณอุดมสมบูรณ์ และเติมพลังให้กับแรงบันดาลใจของคุณในการก้าวต่อไป`)
};

const tr_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ormanını zenginleştirmek ve devam etmek için motivasyonunu artırmak amacıyla odaklanmaya devam et.`)
};

const zh_cn_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`持续累计你的专注成果，让你的森林更丰富，也为自己带来持续前进的动力。`)
};

const zh_tw_starter_challenge_phase_3_description = /** @type {(inputs: Starter_Challenge_Phase_3_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`持續累計你的專注成果，讓你的森林更豐富，也為自己帶來持續前進的動力。`)
};

/**
* | output |
* | --- |
* | "Keep building your focus progress to enrich your forest and fuel your motivation to keep going." |
*
* @param {Starter_Challenge_Phase_3_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_phase_3_description = /** @type {((inputs?: Starter_Challenge_Phase_3_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Phase_3_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_phase_3_description(inputs)
	if (locale === "ar") return ar_starter_challenge_phase_3_description(inputs)
	if (locale === "de") return de_starter_challenge_phase_3_description(inputs)
	if (locale === "es") return es_starter_challenge_phase_3_description(inputs)
	if (locale === "fr") return fr_starter_challenge_phase_3_description(inputs)
	if (locale === "it") return it_starter_challenge_phase_3_description(inputs)
	if (locale === "ja") return ja_starter_challenge_phase_3_description(inputs)
	if (locale === "ko") return ko_starter_challenge_phase_3_description(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_phase_3_description(inputs)
	if (locale === "ru") return ru_starter_challenge_phase_3_description(inputs)
	if (locale === "th") return th_starter_challenge_phase_3_description(inputs)
	if (locale === "tr") return tr_starter_challenge_phase_3_description(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_phase_3_description(inputs)
	return zh_tw_starter_challenge_phase_3_description(inputs)
});